module.exports = __webpack_public_path__ + "img/ETN.c4c85e86.svg";